/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIResponseError } from './APIResponseError';
import {
    APIResponseErrorFromJSON,
    APIResponseErrorFromJSONTyped,
    APIResponseErrorToJSON,
    APIResponseErrorToJSONTyped,
} from './APIResponseError';
import type { GetMeOrgsResp } from './GetMeOrgsResp';
import {
    GetMeOrgsRespFromJSON,
    GetMeOrgsRespFromJSONTyped,
    GetMeOrgsRespToJSON,
    GetMeOrgsRespToJSONTyped,
} from './GetMeOrgsResp';
import type { APIMeta } from './APIMeta';
import {
    APIMetaFromJSON,
    APIMetaFromJSONTyped,
    APIMetaToJSON,
    APIMetaToJSONTyped,
} from './APIMeta';

/**
 * 
 * @export
 * @interface GetMeOrgs200Response
 */
export interface GetMeOrgs200Response {
    /**
     * 
     * @type {APIMeta}
     * @memberof GetMeOrgs200Response
     */
    meta?: APIMeta;
    /**
     * 
     * @type {Array<APIResponseError>}
     * @memberof GetMeOrgs200Response
     */
    errors?: Array<APIResponseError>;
    /**
     * 
     * @type {GetMeOrgsResp}
     * @memberof GetMeOrgs200Response
     */
    result: GetMeOrgsResp;
}

/**
 * Check if a given object implements the GetMeOrgs200Response interface.
 */
export function instanceOfGetMeOrgs200Response(value: object): value is GetMeOrgs200Response {
    if (!('result' in value) || value['result'] === undefined) return false;
    return true;
}

export function GetMeOrgs200ResponseFromJSON(json: any): GetMeOrgs200Response {
    return GetMeOrgs200ResponseFromJSONTyped(json, false);
}

export function GetMeOrgs200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMeOrgs200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'meta': json['meta'] == null ? undefined : APIMetaFromJSON(json['meta']),
        'errors': json['errors'] == null ? undefined : ((json['errors'] as Array<any>).map(APIResponseErrorFromJSON)),
        'result': GetMeOrgsRespFromJSON(json['result']),
    };
}

export function GetMeOrgs200ResponseToJSON(json: any): GetMeOrgs200Response {
    return GetMeOrgs200ResponseToJSONTyped(json, false);
}

export function GetMeOrgs200ResponseToJSONTyped(value?: GetMeOrgs200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'meta': APIMetaToJSON(value['meta']),
        'errors': value['errors'] == null ? undefined : ((value['errors'] as Array<any>).map(APIResponseErrorToJSON)),
        'result': GetMeOrgsRespToJSON(value['result']),
    };
}

